<template>
    <div class="page" id="pro">
        <header class="pageHeader"></header>
        <div id="scroller">
            <pre-loader color="#267962" textColor="#267962" />
        </div>
    </div>
</template>

<script>
import PreLoader from "@/components/App/Pre-loader";
import { rejectAdminLogin } from "@/utils/rejectAdminLogin";
export default {
    name: "Home",
    components: { PreLoader },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        window.axios.get("/user").then((user) => {
            if (rejectAdminLogin(user.data)) {
                this.$router.push("/login?home=show");
                return;
            }

            this.$store.dispatch("updateUser", user.data);
            this.addToken();

            if (this.user.type == "player") {
                if (!this.user.stripe_id) {
                    this.$router.push("/onboard");
                } else {
                    this.$router.push("/player/profile");
                }
            } else if (this.user.type == "pro") {
                this.$router.push("/pro/home");
            }
        });
    },
    methods: {
        addToken() {
            var token = window.localStorage.getItem("token");

            if (token) {
                window.axios.post("/push/token", { token: token }).then(() => {
                    //console.log(token);
                });
            }
        },
    },
};
</script>
